import { NavianceSchool } from "./naviance-school.model";

export interface Product {
    id: number;
    name: string;
}

export interface NavianceSchoolWithProductsData {
    navianceSchool: NavianceSchool;
    products: Product[];
}

export class NavianceSchoolWithProducts implements NavianceSchoolWithProductsData {
    navianceSchool: NavianceSchool;
    products: Product[];

    constructor(data: NavianceSchoolWithProductsData) {
        this.navianceSchool = data.navianceSchool;
        this.products = data.products;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/models/school/naviance-school-with-products.model.ts